import React from 'react'

const Label = ({htmFor, ...props}) => {
    return (
        <>
            <label htmfor={htmFor} {...props}>{props.children}</label>
        </>
    )
}

export default Label
